@if (activeTab === 'system') {
  <table id="systemAccountsSectionTable" class="table table-responsive" aria-describedby="System User Accounts">
    <thead>
      <tr>
        <th scope="col" class="name-table-header sortable" style="width: 12vw" (click)="sortUserAccounts('firstName')">
          First Name
          @if (sortProperty === 'firstName') {
            <span>
              @if (!sortAscending) {
                <span class="fas fa-arrow-down"></span>
              }
              @if (sortAscending) {
                <span class="fas fa-arrow-up"></span>
              }
            </span>
          }
        </th>
        <th scope="col" class="name-table-header sortable" style="width: 12vw" (click)="sortUserAccounts('lastName')">
          Last Name
          @if (sortProperty === 'lastName') {
            <span>
              @if (!sortAscending) {
                <span class="fas fa-arrow-down"></span>
              }
              @if (sortAscending) {
                <span class="fas fa-arrow-up"></span>
              }
            </span>
          }
        </th>
        <th scope="col" class="name-table-header sortable" style="width: 26vw" (click)="sortUserAccounts('email')">
          Email Address
          @if (sortProperty === 'email') {
            <span>
              @if (!sortAscending) {
                <span class="fas fa-arrow-down"></span>
              }
              @if (sortAscending) {
                <span class="fas fa-arrow-up"></span>
              }
            </span>
          }
        </th>
        <th scope="col" class="name-table-header" style="width: 35vw">
          System Account Types
        </th>
        <th scope="col" class="name-table-header" style="width: 15vw">
          Actions
        </th>
      </tr>
    </thead>
    <tbody>
      @for (systemUserAccount of filteredUserList; track systemUserAccount) {
        <tr>
          <td [title]="systemUserAccount.firstName">{{ systemUserAccount.firstName }}</td>
          <td [title]="systemUserAccount.lastName">{{ systemUserAccount.lastName }}</td>
          <td [title]="systemUserAccount.email">{{ systemUserAccount.email }}</td>
          <td>
            <mat-form-field class="clrsgn-form-field">
              <mat-select placeholder="Account Types" [value]="getSelectedAccountTypes(systemUserAccount)" multiple>
                @for (accountType of accountTypes; track accountType) {
                  <mat-option 
                    #matOption 
                    [value]="accountType.key" 
                    (click)="onAccountTypeChange(matOption.selected, systemUserAccount, accountType.key)">
                    {{ accountType.value }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </td>
          <td>
            <button 
              type="button" 
              class="btn-secondary d-flex align-items-center gap-1" 
              (click)="deleteAllConfirmationDialog(systemUserAccount)">
              <i class="fas fa-trash-alt action-icon cursor-hand"></i>
              Delete
            </button>
          </td>
        </tr>
      }
      @empty {
        <tr>
          <td colspan="5" class="text-center py-4">No system users found. Use the 'Add System User' button to add a new system user.</td>
        </tr>
      }
    </tbody>
  </table>
}
